import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class AuthorizationService {
  private isAuthorizedSubject$ = new BehaviorSubject<boolean>(true);
  public isAuthorized$: Observable<boolean>;

  constructor() {
    this.isAuthorized$ = this.isAuthorizedSubject$.asObservable();
  }

  public setIsAuthorized(isAuthorized: boolean) {
    this.isAuthorizedSubject$.next(isAuthorized);
  }
}
